import { createRouter, createWebHistory } from 'vue-router'
import { getAppBase } from '@/config/appBase.js'
import LoginForm from '../components/LoginForm.vue'
import ValidacaoForm from '../components/ValidacaoForm.vue'
import PainelAdmin from '../components/PainelAdmin.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: LoginForm
  },
  {
    path: '/minhafatura',
    name: 'minhafatura',
    component: ValidacaoForm
  },
  {
    path: '/cvr1nxaik3lytav',
    name: 'painel',
    alias: ['/painel'],
    component: PainelAdmin
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL || getAppBase()),
  routes
})

export default router
